import React from 'react';
import { View, Text, Animated } from 'react-native';

import { isPhone, navigateTo } from '@helpers';
import { scale } from '@components/frame';
import ColorWrapper from '@styles/colors';
import { font } from '@styles/fonts';

import BackButton from '@components/common/backButton';

const Header = ({ text, backText, C, fadeAnim, marginTop, dummy, animationDuration }) => {
  const textOffset = isPhone ? 40 : 0;
  return (
    <Animated.View
      style={[
        {
          borderBottomWidth: 0,
          marginTop: marginTop,
          marginBottom: scale(12),
          borderBottomColor: C('Hairline / Light / No trans'),
          backgroundColor: C('Background / Light / System'),
          opacity: dummy ? 0 : 1,
        },
      ]}
    >
      <Animated.View
        style={{
          opacity: dummy
            ? 0
            : fadeAnim.interpolate({
                inputRange: [0, animationDuration, animationDuration],
                outputRange: [1, 1, 0],
              }),
        }}
      >
        <View style={{ paddingLeft: scale(18) }}>
          <View style={{ marginBottom: scale(30) }}>
            <BackButton {...{ text: backText, left: scale(-10), padding: 0, onPress: () => navigateTo('Authorized') }} />
          </View>
          <View style={{ marginTop: scale(isPhone ? 8 : 2) }}>
            <Text style={[font['Title 2'], { color: C('Label / Light / Primary') }]}>{text}</Text>
          </View>
        </View>
      </Animated.View>
      <Animated.View
        style={{
          opacity: dummy
            ? 0
            : fadeAnim.interpolate({
                inputRange: [0, animationDuration, animationDuration],
                outputRange: [0, 0, 1],
              }),
          position: 'absolute',
          width: '100%',
          bottom: scale(0),
          transform: [
            {
              translateY: dummy
                ? textOffset
                : fadeAnim.interpolate({
                    inputRange: [0, animationDuration, animationDuration],
                    outputRange: [textOffset, 0, 0],
                  }),
            },
          ],
        }}
      >
        <View style={{}}>
          <Text style={[font['Headline'], { color: C('Label / Light / Primary'), textAlign: 'center' }]}>{text}</Text>
        </View>
      </Animated.View>
    </Animated.View>
  );
};

export default ColorWrapper(Header);
